import { render, staticRenderFns } from "./TheTabs.vue?vue&type=template&id=6743a82f&"
import script from "./TheTabs.vue?vue&type=script&lang=js&"
export * from "./TheTabs.vue?vue&type=script&lang=js&"
import style0 from "./TheTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports